import { fileService } from "@/services";
import type { DocRenderer } from "@cyntler/react-doc-viewer";
import { toast } from "sonner";

const HeicRenderer: DocRenderer = (props) => {
	const {
		children,
		mainState: { currentDocument },
		...divProps
	} = props;
	return (
		<div
			id="image-renderer"
			className="flex flex-1 items-center justify-center w-full h-full bg-white"
			{...divProps}
		>
			{children ?? (
				<img
					id="image-img"
					src={currentDocument?.fileData as string}
					alt={currentDocument?.fileData as string}
					className="max-w-[95%] max-h-[95%]"
				/>
			)}
		</div>
	);
};

HeicRenderer.fileTypes = ["heic", "heif", "image/heic", "image/heif"];
HeicRenderer.weight = 0;
HeicRenderer.fileLoader = async ({
	documentURI,
	signal,
	fileLoaderComplete,
}) => {
	try {
		const file = await fileService.convertFile(documentURI, { signal });
		const reader = new FileReader();
		reader.onload = () => {
			fileLoaderComplete(reader);
		};
		reader.onerror = (error) => {
			toast.error("Failed to load file");
			throw error;
		};
		reader.readAsDataURL(file);
	} catch (error) {
		toast.error("Failed to load file");
	}
};
export { HeicRenderer };
